import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footerContainer">
        <div className="footerCol">
          <h4>Get to Know Us</h4>
          <ul>
            <li>About LACEGOTA</li>
            <li>Careers</li>
            <li>Press Releases</li>
            <li>Our Story</li>
            {/* Privacy Policy Link Added Here */}
            <li>
              <Link to="/privacy-policy" style={{ color: "inherit", textDecoration: "none" }}>
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>

        <div className="footerCol">
          <h4>Connect with Us</h4>
          <ul>
            <li>Facebook</li>
            <li>Instagram</li>
            <li>Twitter</li>
            <li>WhatsApp</li>
          </ul>
        </div>

        <div className="footerCol">
          <h4>Make Money with Us</h4>
          <ul>
            <li>Sell on LACEGOTA</li>
            <li>Wholesale Partner</li>
            <li>Advertise Products</li>
            <li>Affiliate Program</li>
          </ul>
        </div>

        {/* Is column ko mobile pe span 2 diya hai CSS mein */}
        <div className="footerCol contact-col">
          <h4>Contact Us</h4>
          <ul>
            <li className="address-li">
              <strong>S.G.T.B</strong><br/>
              <span className="address-text">
                5512, Gandhi Market,<br/>
                Sadar Bazar, Delhi - 110006
              </span>
            </li>
            <li>Mob: 8287691638</li>
            <li className="email-link">sgtbofficial5@gmail.com</li>
          </ul>
        </div>
      </div>

      <div className="footerMiddle">
        <div className="footerLogo">LACEGOTA</div>
        <div className="footerOptions">
          <button>🌐 English</button>
          <button>🇮🇳 India</button>
        </div>
      </div>

      <div className="footerBottom">
        <div className="footerBottomGrid">
          <div>
            <h5>Lace Collection</h5>
            <p>Saree Borders & Laces</p>
          </div>
          <div>
            <h5>Wholesale</h5>
            <p>Bulk Orders</p>
          </div>
          <div>
            <h5>Accessories</h5>
            <p>Latkan, Zari, Gota</p>
          </div>
          <div>
            <h5>Tailoring</h5>
            <p>Professional Tools</p>
          </div>
        </div>
        <p className="copyright">
          © 2026 LACEGOTA. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;